var _jsxFileName = "/repo/packages/webassets/src/helpers/TeamMenuHelpers/teamMenuConstants.js",
  _this = this;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import { IconUsers, IconUserPlus, IconUser, IconChartDonut, IconWorkgroup, IconBlocks, IconBooks, IconPulse, IconMobile, IconCart, IconGear, IconCloudArrow } from '@wds/icons';
import TEAM_MENU_COPY from './TeamMenuCopy';
export var ACCOUNT_TYPES = {
  enterpriseAccount: 'enterpriseAccount',
  teamAccount: 'teamAccount'
};
export var USER_ROLES = {
  accountOwner: 'accountOwner',
  admin: 'admin',
  divisionAdmin: 'divisionAdmin',
  user: 'user',
  casual: 'casual'
};
export var SSO_STATE = {
  REQUIRED: 'REQUIRED'
};
export var TEAM_MEMBERSHIP_TYPE = {
  ACCOUNT_OWNER: 'ACCOUNT_OWNER',
  CASUAL: 'CASUAL'
};
export var TAB_IDS = {
  teamSummary: 'teamSummary',
  manageUsers: 'manageUsers',
  addUsers: 'addUsers',
  adminDashboard: 'adminDashboard',
  divisions: 'divisions',
  workgroups: 'workgroups',
  activity: 'activity',
  offlineDevices: 'offlineDevices',
  manageCredits: 'manageCredits',
  settings: 'settings',
  library: 'library',
  contributor: 'contributor',
  dei_reporting: 'dei_reporting'
};
export var getTeamMenuItemConfigs = function getTeamMenuItemConfigs(utSource) {
  var _ref;
  return _ref = {}, _defineProperty(_ref, TAB_IDS.teamSummary, {
    path: createURL('/team/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.TEAM_SUMMARY),
    navItem: 'team summary',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconUsers, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.teamSummary
  }), _defineProperty(_ref, TAB_IDS.manageUsers, {
    path: createURL('/team/users/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.MANAGE_USERS),
    navItem: 'manage users',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconUser, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.manageUsers
  }), _defineProperty(_ref, TAB_IDS.addUsers, {
    path: createURL('/team/add/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.ADD_USERS),
    navItem: 'add users',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconUserPlus, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.addUsers
  }), _defineProperty(_ref, TAB_IDS.adminDashboard, {
    path: createURL('/team/manage/users/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.ADMIN_DASHBOARD),
    navItem: 'admin dashboard',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconChartDonut, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.adminDashboard
  }), _defineProperty(_ref, TAB_IDS.divisions, {
    path: createURL('/team/divisions/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.DIVISIONS),
    navItem: 'divisions',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconBlocks, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.divisions
  }), _defineProperty(_ref, TAB_IDS.workgroups, {
    path: createURL('/team/workgroups/all/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.WORKGROUPS),
    navItem: 'workgroups',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconWorkgroup, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.workgroups
  }), _defineProperty(_ref, TAB_IDS.library, {
    path: createURL('/team/libraries/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.LIBRARY),
    navItem: 'library',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconBooks, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.library
  }), _defineProperty(_ref, TAB_IDS.activity, {
    path: createURL('/team/activity/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.ACTIVITY),
    navItem: 'activity',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconPulse, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.activity
  }), _defineProperty(_ref, TAB_IDS.offlineDevices, {
    path: createURL('/team/devices/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.OFFLINE_DEVICES),
    navItem: 'offline devices',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconMobile, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.offlineDevices
  }), _defineProperty(_ref, TAB_IDS.manageCredits, {
    path: createURL('/team/manage_credits/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.MANAGE_CREDITS),
    navItem: 'manage credits',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconCart, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.manageCredits
  }), _defineProperty(_ref, TAB_IDS.settings, {
    path: createURL('/team/settings/', {
      ut_source: utSource
    }),
    name: t(TEAM_MENU_COPY.SETTINGS),
    navItem: 'settings',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconGear, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.settings
  }), _defineProperty(_ref, TAB_IDS.dei_reporting, {
    path: createURL('/team/dei', {
      ut_source: utSource
    }),
    name: 'Data upload',
    navItem: 'dei',
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement(IconCloudArrow, Object.assign({}, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 142,
          columnNumber: 26
        }
      }));
    },
    id: TAB_IDS.dei_reporting
  }), _ref;
};
//# sourceMappingURL=teamMenuConstants.js.map